import { Injectable } from '@angular/core';
import { Cart, CartModificationList } from '@spartacus/cart/base/root';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GenAutoShipCartConnector } from '../features/auto-ship/core/connectors/auto-ship-cart.connector';
import { GenAutoShipOrderEntry } from '../models/auto-ship.model';
import { GenMultiCartService } from '../features/cart/core/facade/multi-cart.service';

@Injectable()
export class GenAutoShipCartService {
  static readonly CART_ID = 'autoship';

  private readonly cartSubject = new ReplaySubject<Cart>(1);
  readonly cart$ = this.cartSubject.asObservable();

  constructor(
    private connector: GenAutoShipCartConnector,
    private multiCartService: GenMultiCartService,
  ) { }

  load(userId: string): Observable<Cart> {
    return this.connector
      .load(userId, GenAutoShipCartService.CART_ID)
      .pipe(tap((cart) => {
        const cartId = cart.code ?? GenAutoShipCartService.CART_ID;
        this.cartSubject.next(cart);
        this.multiCartService.setActiveCartData(cart, cartId);
      }));
  }

  updateEntries(
    userId: string,
    orderEntries: GenAutoShipOrderEntry[],
  ): Observable<CartModificationList> {
    return this.connector.updateEntries(
      userId,
      GenAutoShipCartService.CART_ID,
      { orderEntries },
    );
  }
}
